function getAddressComponentByType(
  geoCodeAddressComponents: google.maps.GeocoderAddressComponent[],
  type: string,
) {
  return geoCodeAddressComponents.find((addressComponent) =>
    addressComponent.types.includes(type),
  );
}

// /*
//  * Parse Google's geocoding response address components into address object.
//  * Sample geo code https://developers.google.com/maps/documentation/geocoding/start#sample-request
//  */
export const parseGeocodeAddress = (
  geocodeAddress: google.maps.GeocoderResult,
) => {
  const geoCodeAddressComponents = geocodeAddress.address_components;
  const geoCodeLocation = geocodeAddress.geometry.location;
  const streetNumberComponent = getAddressComponentByType(
    geoCodeAddressComponents,
    'street_number',
  );
  const streetNumber = streetNumberComponent
    ? streetNumberComponent.long_name
    : '';

  const streetAddressComponent = getAddressComponentByType(
    geoCodeAddressComponents,
    'route',
  );
  const streetAddress = streetAddressComponent
    ? streetAddressComponent.long_name
    : '';

  const postalCodeComponent = getAddressComponentByType(
    geoCodeAddressComponents,
    'postal_code',
  );
  const postalCode = postalCodeComponent ? postalCodeComponent.long_name : '';

  const localityComponent = getAddressComponentByType(
    geoCodeAddressComponents,
    'locality',
  );
  let locality = localityComponent ? localityComponent.long_name : '';

  if (!locality) {
    const politicalComponent = getAddressComponentByType(
      geoCodeAddressComponents,
      'political',
    );
    locality = politicalComponent ? politicalComponent.long_name : '';
  }

  const regionComponent = getAddressComponentByType(
    geoCodeAddressComponents,
    'administrative_area_level_1',
  );
  const region = regionComponent ? regionComponent.short_name : '';

  const countryComponent = getAddressComponentByType(
    geoCodeAddressComponents,
    'country',
  );
  const country = countryComponent ? countryComponent.short_name : '';

  return {
    externalId: geocodeAddress.place_id,
    externalProviderData: JSON.stringify(geocodeAddress),
    streetAddress: `${streetNumber} ${streetAddress}`,
    city: locality,
    state: region,
    zipcode: postalCode,
    country,
    coordinates: {
      latitude: geoCodeLocation.lat(),
      longitude: geoCodeLocation.lng(),
    },
  };
};
